// extracted by mini-css-extract-plugin
export default {"ContentGralServis":"ServiciosSt_ContentGralServis__AXGZR","ServisContainer":"ServiciosSt_ServisContainer__6v-Xu","btnActionServ":"ServiciosSt_btnActionServ__duW3L"};